<template>
    <vue-progress-bar></vue-progress-bar>
    <metainfo>
        <link rel="icon" :href="$store.state.setting?.image_url ? $store.state.setting?.image_url : '/favicon.ico'">
        <template v-slot:title="{ content }">
            {{ content ? `${content} - ${$store.state.setting?.app_name}` : `${$store.state.setting?.app_name}` }}
        </template>
        <meta name="description" :content="$store.state.setting?.app_description || 'DGG Clothing offers stylish country-themed souvenirs including t-shirts, tote bags, hats, and more. Perfect gifts and travel keepsakes to celebrate your favorite destinations with quality and style.'" />
        <meta name="author" :content="'DGG Clothing'" />
        
        <!-- Open Graph Meta (for Social Sharing like Facebook) -->
        <meta property="og:type" content="website" />
        <meta property="og:url" :content="$store.state.setting?.app_url" />
        <meta property="og:locale" content="id_ID" />
        <meta property="og:site_name" :content="$store.state.setting?.app_name || 'DGG Clothing'" />
        <meta property="og:title" :content="$store.state.setting?.app_name || 'DGG Clothing'" />
        <meta property="og:description" :content="$store.state.setting?.app_description || 'DGG Clothing offers stylish country-themed souvenirs including t-shirts, tote bags, hats, and more. Perfect gifts and travel keepsakes to celebrate your favorite destinations with quality and style.'" />
        <meta property="og:image" :content="$store.state.setting?.image_url || '/default-meta-image.png'" />

        <!-- Twitter Meta Tags -->
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@xetup" />
        <meta name="twitter:title" :content="$store.state.setting?.app_name || 'DGG Clothing'" />
        <meta name="twitter:description" :content="$store.state.setting?.app_description || 'DGG Clothing offers stylish country-themed souvenirs including t-shirts, tote bags, hats, and more. Perfect gifts and travel keepsakes to celebrate your favorite destinations with quality and style.'" />
        <meta name="twitter:image" :content="$store.state.setting?.image_url || '/default-meta-image.png'" />
    </metainfo>
    <main>
        <component :is="$route.meta.layout || 'div'">
            <router-view />
        </component>
    </main>
</template>

<script>
import { useMeta } from 'vue-meta';
import { mapState, mapActions } from 'vuex';

export default {
    setup() {
        useMeta({
            title: '',
            htmlAttrs: {
                lang: 'en',
            }
        });
    },
    computed: {
       ...mapState({
            settings: (state) => state.setting // Renaming it to avoid conflicts
        })
    },
    mounted() {
        this.fetchSettings(); // Ensure settings are fetched
        window.addEventListener('push', (event) => {
            console.log('notificationPush', event);
        });
        if (this.$store.state.setting?.image_url) {
            this.updateFavicon(this.$store.state.setting.image_url);
        }
    },
    methods: {
        ...mapActions(['fetchSettings']),
        updateFavicon(iconUrl) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = iconUrl;
        },
    },
    watch: {
        '$store.state.setting?.image_url': {
            immediate: true,
            handler(newIcon) {
                if (newIcon) {
                    this.updateFavicon(newIcon);
                }
            }
        }
    },
};
</script>

<style scoped></style>
